import type { SVGProps } from "react";
export interface Parcel02CheckIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Parcel02CheckIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Parcel02CheckIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 10.086V8.413l-6.75 3.749v7.556a1.122 1.122 0 0 1 .246 2.175l-.337.102a4 4 0 0 1-1.034.132l-.255-.007a4.1 4.1 0 0 1-1.724-.498l-6-3.28a4.13 4.13 0 0 1-2.146-3.62V8.28c0-.705.181-1.384.508-1.98a1.2 1.2 0 0 1 .169-.28A4.1 4.1 0 0 1 3.02 4.66l2.97-1.624.049-.026L9.02 1.38l.234-.118a4.13 4.13 0 0 1 3.724.119l6 3.28.24.141a4.1 4.1 0 0 1 1.23 1.218 1.1 1.1 0 0 1 .168.28 4.1 4.1 0 0 1 .508 1.98v1.806a1.125 1.125 0 0 1-2.25 0ZM4.331 6.51 11 10.214l2.185-1.215-6.653-3.694zm7.568-3.154a1.88 1.88 0 0 0-1.583-.1l-.215.1-1.235.674 6.636 3.684 2.166-1.204zM3.125 14.722c0 .686.374 1.317.976 1.645l5.774 3.156v-7.361l-6.75-3.749z"
      />
      <path
        fill={color}
        d="M21.204 16.705a1.125 1.125 0 0 1 1.59 1.59l-4.5 4.5c-.438.44-1.15.44-1.59 0l-2-1.999-.077-.086a1.125 1.125 0 0 1 1.583-1.582l.085.077L17.5 20.41l3.705-3.704ZM4.017 12.952a1.125 1.125 0 0 1 1.425-.488l.104.051 3 1.666.099.061A1.126 1.126 0 0 1 7.558 16.2l-.104-.05-3-1.668-.099-.06a1.126 1.126 0 0 1-.338-1.47"
      />
    </svg>
  );
}
